import { render, staticRenderFns } from "./TestWIP.vue?vue&type=template&id=4600a40c&"
import script from "./TestWIP.vue?vue&type=script&lang=js&"
export * from "./TestWIP.vue?vue&type=script&lang=js&"
import style0 from "./TestWIP.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports